const DEFAULT_DRAWER_PANE_STACK_ORDER = 100;

const DRAWER_PANE_STACK_ORDER: Readonly<Record<string, number>> = {
    "owa-app-pane-chatCopilot": 200,
    "owa-app-pane-addins": 300,
};

/**
 * Returns the inline stack order for drawer panes rendered under the ribbon.
 * Higher values place panes further toward inline-end.
 */
export default function getDrawerPaneStackOrder(drawerPaneId?: string): number {
    if (!drawerPaneId) {
        return DEFAULT_DRAWER_PANE_STACK_ORDER;
    }
    
    return DRAWER_PANE_STACK_ORDER[drawerPaneId] ?? DEFAULT_DRAWER_PANE_STACK_ORDER;
}
